import React, { useState, useRef, useEffect } from 'react';
import { Form, Input, Button, Result, Spin, message } from 'antd';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { IoIosSend } from 'react-icons/io';
import moment from 'moment';
import './InfluencerChatBoxComponent.styles.scss';
import { GetConversations } from '../../../apis/Influencer/Chat/GetConversations';
import { useGlobalState } from '../../../store/state';
import { SendConversation } from '../../../apis/Influencer/Chat/SendConversation';

let getMessage;
const { Item } = Form;
const { TextArea } = Input;
const InfluencerChatBoxComponent = ({ activeChat }) => {
  const chatBoxRef = useRef();
  const textareaRef = useRef();
  const [chatSendForm] = Form.useForm();
  const [user] = useGlobalState('user');
  const [company] = useGlobalState('company');
  const [chatLoader, setChatLoader] = useState(true);
  const [chatSettings, setChatSettings] = useState({
    current: 1,
    total: 1,
  });
  const [chatuuid, setChatuuid] = useState('');
  const [refreshInterval] = useState(500);
  const [chatMsg, setChatMsg] = useState([
    // {
    //     id:"id-"+Math.floor(Math.random() * 9999999),
    //     type:"user",
    //     logo:null,
    //     time:moment(),
    //     msgHTML:`This is a user from this use group`
    // },
  ]);
  useEffect(() => {
    setChatMsg([]);
  }, []);
  const loadChats = () =>{
    console.log('activeChat', activeChat);
    GetConversations(user.accessToken, activeChat.campId, chatSettings.current).then(({ response }) => {
      console.log('submission', response);
      setChatuuid(response.conversation_uuid || '');
      setChatMsg(response.conversations.reverse());
      setChatSettings({
        ...chatSettings,
        current: response.nextPage !== null ? response.nextPage : 1,
      });
      setChatLoader(false);
    });
  };
  useEffect(()=>{
    setChatLoader(true);
    setChatuuid('');
    setChatMsg([]);
    if (activeChat !== null) {
      getMessage = setInterval(loadChats, refreshInterval);
    }
    return () => clearInterval(getMessage);
  }, [activeChat]);

  useEffect(()=>{ // scroll bar to bottom on loading
    if (chatMsg.length) {
      chatBoxRef.current.scrollToBottom();
    }
  }, [chatLoader]);
  const submitChatMsg = (value) =>{
    // console.log("value",value)
    if (value.user_msg.length) {
      // let _new_user_node = {
      //     id:"id-"+Math.floor(Math.random() * 9999999),
      //     type:"user",
      //     logo:null,
      //     time:moment(),
      //     msgHTML:value.user_msg
      // }
      let _data = {};
      if (!chatMsg.length) {
        _data = {
          message: value.user_msg,
          referenceId: activeChat.campId,
        };
      } else {
        _data = {
          message: value.user_msg,
          referenceId: activeChat.campId,
          uuid: chatuuid,
        };
      }
      SendConversation(user.accessToken, _data).then(({ status })=>{
        if (status === 200) {
          console.log('API:submitted');
          chatSendForm.resetFields();
          setTimeout(()=>{
            textareaRef.current.focus();
            chatBoxRef.current.scrollToBottom();
          }, 1010);
        } else {
          message.error('There is some issue while sending your message');
        }
      });
    }
  };
  const TriggerFormSubmit = (e) =>{
    if (e.keyCode == 13 && e.shiftKey == false) {
      e.preventDefault();
      chatSendForm.submit();
    }
  };

  // const scrollFrame = (vals) =>{
  //     if (vals.scrollTop === 0){
  //         console.log("vals", vals.scrollTop)

  //     }
  // }
  return (
    <div className="common_card chat_box">
      {
        activeChat !== null ?
          <>
            <div className="chat_box_details px-3 py-2">
              <h4 className="chat_box_details--title mb-1">{activeChat.title}</h4>
              <p className="chat_box_details--id m-0">{activeChat.campId}</p>
            </div>
            <div className="chat_box_area">
              {chatLoader?(
                <div className="d-flex w-100 h-100 align-items-center justify-content-center">
                  <Spin size="large" />
                </div>
              ):
                (
                  <Scrollbars
                    ref={chatBoxRef}
                    // onScrollFrame={scrollFrame}
                    style={{ maxHeight: '100%', height: '100%' }}>
                    {chatMsg.length ?
                      chatMsg.map(({ _id, updatedAt, senderModel, message })=>(
                        <div key={_id}
                          className={`chat_box_area_msg rec ${senderModel}`}>
                          {/* <div className="chat_box_area_msg--badge">
                                                <img src={logo} className="img-fluid" alt="" />
                                            </div> */}
                          <div className="chat_box_area_msg_holder">
                            <div className="chat_box_area_msg_holder--time">
                              {moment(moment(updatedAt).subtract(1, 'minitus')).fromNow()}
                            </div>
                            <div className="chat_box_area_msg_holder--content">
                              {message}
                            </div>
                          </div>
                        </div>
                      )):
                      (
                        <div className="d-flex w-100 align-items-center justify-content-center">
                          <Result
                            title="Conversation not started"
                            subTitle="You can start conversation by sending a message"
                          />
                        </div>
                      )
                    }
                  </Scrollbars>
                )
              }
            </div>
            <div className="chat_box_sent">
              <Form
                form={chatSendForm}
                onFinish={submitChatMsg}
                name="chatSubmitForm"

              >
                <div className="d-flex">
                  <Item
                    name="user_msg"
                    className="col-10 px-1"
                  >
                    <TextArea
                      ref={textareaRef}
                      onKeyDown={TriggerFormSubmit}
                      placeholder="Type here"
                      className="chat_box_sent--textarea"
                      style={{ height: 40 }}
                    ></TextArea>
                  </Item>
                  <Item className="col px-1">
                    <Button htmlType="submit"
                      className="common_button w-100">Send  <IoIosSend/></Button>
                  </Item>
                </div>
              </Form>
            </div>
          </>:
          (
            <div className="d-flex align-items-center justify-content-center h-100">
              <Result title="No chat selected" />
            </div>
          )
      }
    </div>
  );
};

export default InfluencerChatBoxComponent;
